export const SiteTypes = {
  Unmanaged: 'Unmanaged',
  Essentials: 'Essentials',
  Advanced: 'Advanced',
  Enterprise: 'Enterprise',
};

export type SiteTypes = (typeof SiteTypes)[keyof typeof SiteTypes];
